import React from 'react';
import { useNavigate } from 'react-router-dom';

const MonthlyAssessmentSuccess = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-xl shadow-sm p-8 text-center">
        {/* Success Icon */}
        <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100 mb-6">
          <svg className="h-10 w-10 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
          </svg>
        </div>

        {/* Success Message */}
        <h2 className="text-2xl font-bold text-gray-900 mb-4">
          Assessment Submitted Successfully!
        </h2>
        <p className="text-gray-600 mb-8">
          Thank you for completing your monthly assessment. Your care team will review your responses and follow up if needed.
        </p>

        {/* Action Buttons */}
        <div className="space-y-4">
          <button
            onClick={() => navigate('/dashboard')}
            className="w-full px-6 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 font-medium transition-colors"
          >
            Go to Dashboard
          </button>
          {/* <button
            onClick={() => navigate('/appointments')}
            className="w-full px-6 py-3 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 font-medium transition-colors"
          >
            View Appointments
          </button> */}
        </div>

        {/* Additional Info */}
        <div className="mt-8 text-sm text-gray-500">
          <p>Your next assessment will be due in 30 days.</p>
          <p className="mt-2">
            If you have any immediate concerns, please don't hesitate to contact your care team.
          </p>
        </div>
      </div>
    </div>
  );
};

export default MonthlyAssessmentSuccess; 